import React from 'react'
import { connect } from 'react-redux'
import { prettyScopeNames } from './prettyScopes.js'

import { Row } from 'components/Layout'
import { Scope } from '../../components/Scope'
// import { Button } from 'components/Button'

const CheckBoxGroup = ({
	label,
	required,
	options,
	input,
	value,
	meta,
	name,
	onChange,
	changeField
}) => {
	return (
		<span>
			{options.map((option, index) => {
				return (
					<Scope
						key={index}
						name={`${name}[${index}]`}
						value={option.value}
						label={option.label}
						checked={value.indexOf(option.value) !== -1}
						onChange={event => {
							const newValue = [...value]
							if (event.target.checked) {
								newValue.push(option.value)
							} else {
								newValue.splice(
									newValue.indexOf(option.value),
									1
								)
							}

							return changeField(name, newValue)
						}}
					/>
				)
			})}
		</span>
	)
}
class FieldScopes extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			processing: false
		}
	}
	updateScopesList(scope, value, name) {
		this.props.changeField(this.props.fieldId, [scope])
	}

	render() {
		const {
			fieldId,
			error, // eslint-disable-line no-unused-vars
			changeField, // eslint-disable-line no-unused-vars
			dispatch, // eslint-disable-line no-unused-vars
			disabled, // eslint-disable-line no-unused-vars
			...rest
		} = this.props
		return (
			<Row notPadded topMargin bottomMargin>
				<CheckBoxGroup
					{...rest}
					id={fieldId}
					changeField={changeField}
					options={Object.keys(
						prettyScopeNames
					).map((value, index) => {
						return { value, label: prettyScopeNames[value] }
					})}
				/>
			</Row>
		)
	}
}

// const mapStateToProps = (state, ownProps) => null

// const mapDispatchToProps = (dispatch, ownProps) => null

FieldScopes.propTypes = {
	id: React.PropTypes.string,
	error: React.PropTypes.bool
}

const ConnectedFieldScopes = connect(null, null)(FieldScopes)

export default ConnectedFieldScopes



// WEBPACK FOOTER //
// ./src/containers/Forms/FieldScopes.js